import RadialGaugeChart from './RadialGaugeChart';

export default RadialGaugeChart;
export { RadialGaugeChart };
